// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

// packages
import { index } from 'd3-array';

// local
import { COUNTY_URL, SF_URL } from './constants.js';

import { createFeed, createRaceFeed, indexByApId } from './stores.js';
import { renderSvelteComponent } from './utils/render.js';

//components
import Results from './components/Results.svelte';
import LocalResults from './components/LocalResults.svelte';
import Watching from './components/Watching.svelte';

const crosswalk = index(window.CROSSWALK, indexByApId);

async function main() {
  // raw feed
  const feed = await createFeed(COUNTY_URL);
  const apFeed = await createFeed(SF_URL);

  const mayorFeed = /**  @type {import('./types.d').RaceFeed}  */ (
    createRaceFeed(apFeed, 'CA-M8957-2022-06-07')
  );

  renderSvelteComponent(
    Results,
    /** @type {HTMLElement} */ (document.getElementById('Mayor')),
    { race: mayorFeed, face: true, crosswalk }
  );

  const sheriffFeed = /**  @type {import('./types.d').RaceFeed}  */ (
    createRaceFeed(apFeed, 'CA-08946-2022-06-07')
  );

  renderSvelteComponent(
    Results,
    /** @type {HTMLElement} */ (document.getElementById('Sheriff')),
    { race: sheriffFeed, face: true, crosswalk }
  );

  const racesOnPage = document.querySelectorAll('.race-result');
  /**  @type {import('./types.d').RaceFeed}  */

  for (let idx = 0; idx < racesOnPage.length; idx++) {
    const target = racesOnPage[idx];
    const id = target.id;

    const race = /**  @type {import('./types.d').RaceFeed}  */ (
      createRaceFeed(feed, id)
    );

    renderSvelteComponent(
      LocalResults,
      /** @type {HTMLElement} */ (document.getElementById(id)),
      { race: race }
    );
  }

  // RACES WE ARE WATCHING
  const watchingRace = document.querySelectorAll('.watching');

  for (let idx = 0; idx < watchingRace.length; idx++) {
    const t = watchingRace[idx];
    const watching_id = t.id;
    // console.log(id);
    const watchingFeed = /**  @type {import('./types.d').RaceFeed}  */ (
      createRaceFeed(apFeed, watching_id)
    );

    renderSvelteComponent(
      Watching,
      /** @type {HTMLElement} */ (document.getElementById(watching_id)),
      { race: watchingFeed }
    );
  }

  // const testracefeed = /**  @type {import('./types.d').RaceFeed}  */ (
  //   createRaceFeed(feed, '8238')
  // );

  // renderSvelteComponent(
  //   LocalResults,
  //   /** @type {HTMLElement} */ (document.getElementById('8238')),
  //   { race: testracefeed }
  // );
}

main().catch(console.error);
